<template>
  <v-container>
    <v-layout>
      <v-flex>
        <h3 class="headline mt-3">{{ $t('Applicants') }}</h3>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="primary" :loading="loading" @click="exportApplicant()">Export</v-btn>
        <v-btn outline color="primary" @click="showSearch = !showSearch">
          <v-icon class="mr-1">search</v-icon>Search
          <v-icon class="ml-1">{{ showSearch ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <filter-applicant v-model="filters" v-if="showSearch" @onSearch="onSearch"></filter-applicant>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <applicant v-model="props.item" :key="props.item.userid"></applicant>

        <!-- <customer-item v-model="props.item"></customer-item> -->
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No applicant') }}</div>
    </v-data-table>

    <div class="text-xs-center mt-4">
      <v-btn
        outline
        color="primary"
        :loading="loading"
        :disabled="!hasNext"
        @click="getMoreApplicants"
        >{{ $t('Next') }}</v-btn
      >
    </div>
    <div class="mb-5 mt-5"></div>
  </v-container>
</template>

<script>
import api from '@/api'
import Applicant from './Applicant'
import FilterApplicant from './FilterApplicant'
import XLSX from 'xlsx'
import moment from 'moment'
export default {
  data() {
    var headers = []

    headers = headers.concat([
      { text: '', sortable: false },
      {
        text: this.$t('รูป'),
        sortable: false
      },
      { text: this.$t('Name'), value: 'first_name' },
      {
        text: this.$t('Education'),
        sortable: false
      },
      { text: this.$t('Phoneno'), value: 'phoneno' },
      { text: this.$t('Lineid'), value: 'lineid' },
      { text: this.$t('Email'), value: 'email' },
      { text: this.$t('Interest'), value: 'interest' },
      { text: this.$t('Source'), value: 'urlsource' }
    ])

    return {
      showSearch: false,
      filteredHeader: [],
      pagination: { rowsPerPage: -1, sortBy: '' },
      loading: true,
      hasNext: false,
      limit: 100,
      offset: 0,
      headers: headers,
      users: [],
      filters: {
        urlsource: null,
        interest: null,
        first_name: null,
        last_name: null,
        email: null,
        phoneno: null,
        lineid: null,
        educationlevel: null,
        institution: null,
        major: null,
        gpa: null
      }
    }
  },
  components: {
    Applicant,
    FilterApplicant
  },
  async mounted() {
    this.loading = true
    try {
      var users = await this.getLoadApplicants(this.limit, this.offset)
      this.offset += this.limit
      this.users = this.users.concat(users)
      this.loading = false
    } catch (error) {
      console.log(error)
      this.loading = false
    }
  },
  methods: {
    async onSearch() {
      this.loading = true
      try {
        this.offset = 0
        this.users = []
        var users = await this.getLoadApplicants(this.limit, this.offset)
        this.offset += this.limit
        this.users = this.users.concat(users)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    getLoadApplicants: function (limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = vm.filters
        data.pageid = vm.pageid
        data.limit = limit
        data.offset = offset

        api.getAllApplicants(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    async getMoreApplicants() {
      this.loading = true
      try {
        var users = await this.getLoadApplicants(this.limit, this.offset)
        this.offset += this.limit
        this.users = this.users.concat(users)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    onFailLoad: async function (index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    exportApplicant: async function (offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 10000
      vm.loading = true

      try {
        var applicants = await this.getLoadApplicants(limit, offset)

        let dup_count = applicants.reduce((prev, curr) => {
          if (prev && prev.hasOwnProperty(curr.first_name + '_' + curr.last_name)) {
            prev[curr.first_name + '_' + curr.last_name].push({
              userid: curr.userid,
              lineid: curr.lineid,
              interest: curr.interest,
              createdate: curr.createdtime
            })
            console.log(
              curr.first_name + '_' + curr.last_name,
              'has more than',
              prev[curr.first_name + '_' + curr.last_name]
            )
          } else
            prev[curr.first_name + '_' + curr.last_name] = [
              {
                userid: curr.userid,
                lineid: curr.lineid,
                interest: curr.interest,
                createdate: curr.createdtime
              }
            ]
          return prev
        }, {})
        console.log(dup_count)

        if (applicants && applicants.length > 0) {
          // csvContent +=
          //   'ID,Name,Phone,Line ID,Email,Interest,Nationality,Country,Province,Address,Date of Birth,Source,Education,Experience,Language,Skill'

          // csvContent += '\r\n'
          var json = []

          $.each(applicants, function (index, val) {
            let row = ''
            let urlsource = ''
            if (val.urlsource == 'diyresume') {
              urlsource = `DIY Resume`
            } else if (val.urlsource == 'event') {
              urlsource = `Event`
            } else {
              urlsource = `-`
            }

            // if (vm.$store.getters.getPackage == 'premium') {
            //   row += '"' + (val.id ? val.id : '-') + '",'
            // }

            // row +=
            //   '"' +
            //   `${val.title} ${val.first_name} ${val.last_name}`.replace(/\r?\n|\r/g, ' / ') +
            //   '",'

            // row += `"${val.phoneno}","${
            //   val.lineid ? val.lineid.replace(/\r?\n|\r/g, ' / ') : '-'
            // }","${val.email.replace(/\r?\n|\r/g, ' / ')}","${
            //   val.interest ? val.interest.replace(/\r?\n|\r/g, ' / ') : '-'
            // }","${val.nationality ? val.nationality.replace(/\r?\n|\r/g, ' / ') : '-'}","${
            //   val.country ? val.country : '-'
            // }","${val.province ? val.province : '-'}","${
            //   val.addresstext ? val.addresstext : '-'
            // }","${val.dob ? val.dob.replace(/\r?\n|\r/g, ' / ') : '-'}",`

            // if (val.urlsource == 'diyresume') {
            //   row += `"DIY Resume",`
            // } else if (val.urlsource == 'event') {
            //   row += `"Event",`
            // } else {
            //   row += `"-",`
            // }

            var educations = JSON.parse(val.educationjson)
            var educations_text = []
            for (let index = 0; index < educations.length; index++) {
              const edu = educations[index]

              var education = `${edu.degree}  ${edu.country ? `(${edu.country})` : ''} ${
                edu.faculty ? `${edu.faculty}` : ''
              } ${edu.major ? `${edu.major}` : ''} ${edu.gpa ? `GPA ${edu.gpa}` : ''} ${
                edu.startdate
              } - ${edu.enddate ? edu.enddate : 'Present'}`

              educations_text.push(education)
            }

            // row += '"' + (educations_text.length > 0 ? educations_text.join(' | ') : '-') + '",'

            var experiences = JSON.parse(val.experiencejson)
            var experiences_text = []
            for (let index = 0; index < experiences.length; index++) {
              const exp = experiences[index]

              var experience = `${exp.companyname} ${exp.position ? exp.position : ''} ${
                exp.responsibility
              } ${exp.startdate} - ${exp.enddate && !exp.iscurrent ? exp.enddate : 'Present'}`
              experiences_text.push(experience)
            }
            // row += '"' + (experiences_text.length > 0 ? experiences_text.join(' | ') : '-') + '",'

            var languages = JSON.parse(val.languagejson)
            var languages_text = []

            for (let index = 0; index < languages.length; index++) {
              const lang = languages[index]

              var language = `${lang.lang} ${lang.type ? `(${lang.type})` : ''} ${
                lang.score ? lang.score : 0
              }`

              languages_text.push(language)
            }

            // row += '"' + (languages_text.length > 0 ? languages_text.join(' | ') : '-') + '",'

            var skills = JSON.parse(val.skilljson)
            var skills_text = []

            for (let index = 0; index < skills.length; index++) {
              const s = skills[index]
              var skill = `${s.category} ${s.skill ? `(${s.skill})` : ''} ${s.level ? s.level : 0}`
              skills_text.push(skill)
            }

            var a = moment()
            var b = moment(val.dob)
            let age = a.diff(b, 'years') // 86400000

            // json.push({
            //   ID: val.userid,
            //   Name: `${val.title} ${val.first_name} ${val.last_name}`,
            //   Phone: val.phoneno,
            //   'Line ID': val.lineid ? val.lineid : '-',
            //   Email: val.email,
            //   Interest: val.interest ? val.interest : '-',
            //   Nationality: val.nationality ? val.nationality : '-',
            //   Country: val.country ? val.country : '-',
            //   Province: val.province ? val.province : '-',
            //   Address: val.addresstext ? val.addresstext : '-',
            //   'Date of Birth': val.dob ? val.dob : '-',
            //   Source: urlsource,
            //   Education: educations_text.length > 0 ? educations_text.join('\n') : '-',
            //   Experience: experiences_text.length > 0 ? experiences_text.join('\n') : '-',
            //   Language: languages_text.length > 0 ? languages_text.join('\n') : '-',
            //   Skill: skills_text.length > 0 ? skills_text.join('\n') : '-'
            // })

            json.push({
              ID: val.userid,
              photo: val.photourl,
              คำนำหน้า: val.title,
              Name: val.first_name,
              surname: val.last_name,
              อายุ: age,
              Phone: val.phoneno,
              Email: val.email,
              'Line ID': val.lineid ? val.lineid : '-',
              Interest: val.interest ? val.interest : '-',
              Nationality: val.nationality ? val.nationality : '-',
              Country: val.country ? val.country : '-',
              Province: val.province ? val.province : '-',
              Address: val.addresstext ? val.addresstext : '-',
              Source: urlsource,
              'ระดับการศึกษา / Education':
                educations && educations.length > 0 && educations[0].degree
                  ? educations[0].degree
                  : '-',
              'มหาวิทยาลัยหรือสถาบันการศึกษา / University or Institution (เฉพาะการศึกษาสูงสุด)':
                educations && educations.length > 0 && educations[0].institution
                  ? educations[0].institution
                  : '-',
              'คณะ / Faculty':
                educations && educations.length > 0 && educations[0].faculty
                  ? educations[0].faculty
                  : '-',
              'สาขา / Major':
                educations && educations.length > 0 && educations[0].major
                  ? educations[0].major
                  : '-',
              'ตำแหน่งงานปัจจุบัน / Position':
                experiences && experiences.length > 0 && experiences[0].position
                  ? experiences[0].position
                  : '-',
              'บริษัท / Company':
                experiences && experiences.length > 0 && experiences[0].companyname
                  ? experiences[0].companyname
                  : '-',
              'ระดับการศึกษา (ชั้นปี)':
                educations && educations.length > 0 && educations[0].educationlevel
                  ? educations[0].educationlevel
                  : '-',
              GPA:
                educations && educations.length > 0 && educations[0].gpa ? educations[0].gpa : '-',
              'ปีเริ่มการศึกษา – จบการศึกษา':
                educations && educations.length > 0
                  ? (educations[0].startdate ? educations[0].startdate : '') +
                    (educations[0].enddate ? ' - ' + educations[0].enddate : ' - ปัจจุบัน')
                  : '-',
              โครงการที่สนใจ: val.interest_intern,
              วันเวลาที่สมัคร: moment(val.createdtime).format('YYYY/MM/DD HH:mm')
            })
          })

          // vm.exportCsv(csvContent, 'applicant_' + offset)

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'applicant_' + (offset + 1) + '.xlsx')

          offset += limit
          if (applicants.length >= limit) {
            vm.exportApplicant(offset)
          } else {
            vm.loading = false
          }
        }
      } catch (error) {
        vm.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/scgcareer/Applicants.vue